/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationCourseregistrationidStatusApproved202,
  PutApiV1CourseregistrationCourseregistrationidStatusApproved400,
  PutApiV1CourseregistrationCourseregistrationidStatusApproved401,
  PutApiV1CourseregistrationCourseregistrationidStatusApproved500,
  PutApiV1CourseregistrationCourseregistrationidStatusApprovedMutationResponse,
  PutApiV1CourseregistrationCourseregistrationidStatusApprovedPathParams,
} from "../../types/courseRegistrationDocumentApprovalController/PutApiV1CourseregistrationCourseregistrationidStatusApproved.ts";

export const putApiV1CourseregistrationCourseregistrationidStatusApprovedPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CourseregistrationCourseregistrationidStatusApprovedPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationCourseregistrationidStatusApproved202Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationCourseregistrationidStatusApproved202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationCourseregistrationidStatusApproved400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationCourseregistrationidStatusApproved400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationCourseregistrationidStatusApproved401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationCourseregistrationidStatusApproved401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationCourseregistrationidStatusApproved500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationCourseregistrationidStatusApproved500>;

export const putApiV1CourseregistrationCourseregistrationidStatusApprovedMutationResponseSchema =
  z.lazy(
    () => putApiV1CourseregistrationCourseregistrationidStatusApproved202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationCourseregistrationidStatusApprovedMutationResponse>;
